// extracted by mini-css-extract-plugin
module.exports = {"Section":"Section_Section__pJ0Lk","inner":"Section_inner__2mKjd","margin":"Section_margin__EoKJc"};